<template>
    <ValidationObserver class="form" ref="form">
        <div class="mb-3">
            <h5>your details</h5>

            <div class="row">
                <div class="col-sm-12 mb-3">
                    <label for="" class="form-label">Full Name:*</label>
                    <div class="row">
                        <ValidationProvider class="col-sm-6 mb-3" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <input
                                    type="text"
                                    id="first_name"
                                    placeholder="First Name"
                                    :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                    v-model="form.first_name"
                                >
                            </div>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>

                        <ValidationProvider class="col-sm-6 mb-3" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <input
                                    type="text"
                                    id="last_name"
                                    placeholder="Last Name"
                                    :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                    v-model="form.last_name"
                                >
                            </div>

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                </div>

                <ValidationProvider
                    class="col-sm-12 mb-5"
                    name="Phone"
                    rules="required|us_phone_number"
                    v-slot="{ errors }"
                >
                    <label for="" class="form-label">Phone Number:*</label>
                    <div class="form-group mb-0">
                        <input
                            type="text"
                            id="phone"
                            :class="['form-control mb-1', {'input-error' : errors[0] }]"
                            v-mask="'+1(###)-###-####'"
                            v-model="form.phone"
                        >

                        <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                            {{ errors[0] }}
                        </div>

                        <small>You will receive a text message reminder before your appointment</small>
                    </div>
                </ValidationProvider>

                <ValidationProvider class="col-sm-12 mb-3" name="Email" rules="required|email" v-slot="{ errors }">
                    <label for="email" class="form-label">Email Address:*</label>
                    <div class="form-group">
                        <input id="email" type="email" :class="['form-control mb-1', {'input-error' : errors[0] }]" v-model="form.email">

                        <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                            {{ errors[0] }}
                        </div>

                        <small>You will receive an email confirmation once booking is completed along with a link to
                            Boat Rental Contract that you can sign digitally. Please check your spam folder.</small>
                    </div>
                </ValidationProvider>

                <div class="col-12">
                    <label for="" class="form-label">Appointment Notes <em>(optional)</em>:</label>
                    <div class="form-group">
                        <textarea class="form-control" v-model="form.notes"></textarea>
                    </div>
                </div>
            </div>

            <div class="blue-box mb-4">
                <h5>FLORIDA BOATING SAFETY REQUIREMENTS</h5>
                <p>Florida law requires anyone born on or after January 1, 1988, who operates a motorboat of ten (10)
                    horsepower or greater, to successfully complete an approved boating safety course & have in his/her
                    possession photo ID & a Boating Safety Education ID card issued by the FWC.</p>
                <p>Free Boating Safety Course <a href="https://www.boatus.org/florida" target="_blank">https://www.boatus.org/florida/</a>
                </p>
            </div>

            <div class="row">
                <ValidationProvider class="col-12 mb-3" name="Completion" rules="required" v-slot="{ errors }">
                    <div class="form-group mb-0">
                        <div class="form-check">
                            <input
                                class="form-check-input-checkbox mb-1"
                                type="checkbox"
                                id="completed"
                                :true-value="true"
                                :false-value="null"
                                v-model="form.agreement"
                            >
                            <label for="completed" :class="['form-check-label', {'label-error' : errors[0], 'animated shake' : errors[0] && animated }]">
                                I acknowledge that I was born before January 1, 1988, or have successfully completed FL
                                Boating Safety Course, or will request to hire a captain at booking (subject to
                                availability). *
                            </label>
                        </div>
                    </div>
                </ValidationProvider>
            </div>
        </div>

        <div class="mb-3">
            <h5>Passengers Information</h5>
            <p>Boats fit up to {{ boatLimit }} passengers and a captain ({{ boatLimit + 1 }} total including children).</p>

            <div class="row">
                <ValidationProvider class="col-sm-6 mb-3" name="Adults and Children" rules="required" v-slot="{ errors }">
                    <label for="adult" class="form-label">Number of Adults and Children:*</label>
                    <div class="form-group mb-1">
                        <select id="adult" :class="['custom-select', {'input-error' : errors[0] }]"
                                v-model="form.adults">
                            <option :value="null" disabled>Select One</option>
                            <!--                            <option value="0">0</option>-->
                            <option v-for="adult in boatLimit" :key="adult" :value="adult">
                                {{ adult }}
                            </option>
                        </select>
                    </div>

                    <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <div class="col-sm-6 mb-3">
                    <label class="form-label">Amount of kids under 13 years:</label>
                    <div class="form-group mb-0">
                        <ValidationProvider name="Amount of kids" :rules="{ required: false, max_value: kidsAmount }" v-slot="{ errors }">
                            <input
                                type="text"
                                v-mask="`##`"
                                :class="['form-control mb-1', {'input-error' : errors[0] }]"
                                v-model="form.children"
                            >

                            <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                    <!--                    <i class="fa fa-plus-circle add__child" @click="addChild"></i>-->
                </div>
            </div>
        </div>

        <div class="mb-3">
            <h5>Pick up location</h5>

            <BookingMap
                :map_location="form.location_id"
                :locations="boat.locations"
                @location="setLocation"
            ></BookingMap>
        </div>

        <div class="mb-3">
            <h5>Cancellation Policy</h5>

            <ul>
                <li>Requests to reschedule or cancel must be made 48 hours ahead of the reservation time for 100%
                    Refund, 24 hours ahead of the reservation time for 50% Refund.
                </li>
                <li> **The day of the reservation there is NO Refund.</li>
                <li>**We reserve the right to cancel a reservation due to severe weather conditions or mechanical issues
                    of the boat. You will not be charged a cancellation fee in that instance.
                </li>
            </ul>

            <div class="row">
                <ValidationProvider class="col-12 mb-3" name="Agreement" rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input-checkbox mb-1"
                                type="checkbox"
                                id="agreement"
                                :true-value="true"
                                :false-value="null"
                                v-model="form.terms"
                            >
                            <label for="agreement" :class="['form-check-label', {'label-error' : errors[0], 'animated shake' : errors[0] && animated }]">
                                I have read and agree to the terms above
                            </label>
                        </div>
                    </div>
                </ValidationProvider>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import resetAnimation from "@/js/mixins/reset-animation";
import BookingMap from "./BookingMap";

export default {
    name: "BookingForm",
    components: {BookingMap},
    mixins: [resetAnimation],
    props: {
        boat: {
            type: Object
        },
        info: {
            type: Object
        }
    },
    data() {
        return {
            form: {
                first_name: null,
                last_name: null,
                phone: null,
                email: null,
                notes: null,
                adults: null,
                children: null,
                location_id: this.boat.location.id,
                agreement: null,
                terms: null,
            },
        }
    },
    computed: {
        boatLimit() {
            return this.boat.limit ? this.boat.limit : 10
        },
        adultsSelected() {
            return this.form.adults
        },
        kidsAmount() {
            return this.adultsSelected ? this.adultsSelected : this.boatLimit
        }
    },
    methods: {
        setLocation(location) {
            this.form.location_id = location;
        },
        addChild() {
            const {children} = this.form;

            children.push(null)
        },
        focusInput(key) {
            $(`#children-${key}`).focus()
        }
    }
}
</script>

<style scoped>
.field-validation-error {
    color: #d54141;
    font-family: Open Sans, sans-serif;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 0;
}

.input-error {
    border: 2px solid #ffb996 !important;
    background-color: #fff8f6 !important;
    border-radius: 3px !important;
}

.form-check-label:hover {
    cursor: pointer;
}

.label-error {
    color: #d54141 !important;
}

.add__child {
    color: #158898;
    cursor: pointer;
    padding-right: 10px;
    float: right;
}
</style>
